import { UserHome } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.HOME.path,
      name: "Home",
      key: routesMap.HOME.path,
      commonRoute: false,
      private: false,
      withAuth: false,
      belongsToHeader: false,
      element: <UserHome />,
    },
  ];
}
